import { Component, OnInit, Input, OnDestroy, HostListener, Output, EventEmitter } from '@angular/core';
import { Contexto } from '../../models/contexto';
import { LocalStorageService } from '../../services/local-storage.service';
import { VentanaUtils } from '../../utils/ventana.utils';
import { MatDialog } from '@angular/material/dialog';
import { HandlerType } from '../../models/HandlerType';
import {MailService} from '../asistencia-mail/services/mail.service'
import { FormElements } from '../../models/FormElements';


@Component({
  selector: 'app-asistencia-mail',
  templateUrl: './asistencia-mail.component.html',
  styleUrls: ['./asistencia-mail.component.scss']
})
export class AsistenciaMailComponent implements OnInit, OnDestroy {

  @Input()  public ctx: Contexto;
  @Input() public formElements: FormElements;
  minimized = false;
  handlerType = new HandlerType();
  @Output() switchHandlerEmitter = new EventEmitter<Object>();
  
  /**
   * Constructor
   * @param localstorage 
   * @param window 
   * @param dialog 
   * @param rest 
   */
  constructor(private localstorage: LocalStorageService,
              private window: VentanaUtils,
              public dialog: MatDialog,
              public rest: MailService) {
                this.handlerType.chat = false;
                this.handlerType.email = true;
  }

  /**
  * Inicializacion del componente
  */
  ngOnInit() {
    this.localstorage.setWindowStatus('max');
    this.localstorage.setHandlerType('email');
  }



  /**
   * Destruccion del componente
   */
  ngOnDestroy() {
  }


  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event: Event) {
  }

  emitSwitchHandlerEmitter(event){
    this.switchHandlerEmitter.emit(event);
  }

}
